module.exports = __webpack_public_path__ + "img/partner-list-6.cc1c2328.png";